<template>
  <vs-tabs :position="isSmallerScreen ? 'top' : 'left'" class="tabs-shadow-none" id="profile-tabs" :key="isSmallerScreen">

    <!-- GENERAL -->
    <vs-tab icon-pack="feather" icon="icon-user" :label="!isSmallerScreen ? 'Profile' : ''">
      <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
        <user-settings-profile />
      </div>
    </vs-tab>
    <vs-tab icon-pack="feather" icon="icon-lock" :label="!isSmallerScreen ? 'Change Password' : ''">
      <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
        <user-settings-change-password />
      </div>
    </vs-tab>
    <vs-tab icon-pack="feather" icon="icon-info" :label="!isSmallerScreen ? 'Club Details' : ''">
      <div class="tab-info md:ml-4 md:mt-0 mt-4 ml-0">
        <user-settings-club-info />
      </div>
    </vs-tab>
    <vs-tab icon-pack="feather" icon="icon-mail" :label="!isSmallerScreen ? 'Mails' : ''">
      <div class="tab-info md:ml-4 md:mt-0 mt-4 ml-0">
        <user-mail-info />
      </div>
    </vs-tab>
  </vs-tabs>
</template>

<script>
import UserMailInfo from "./UserMailInfo.vue"
import UserSettingsProfile from "./UserSettingsProfile.vue"
import UserSettingsChangePassword from "./UserSettingsChangePassword.vue"
import UserSettingsClubInfo from "./UserSettingsClubInfo.vue"
import UserSettingsClasses from "./UserSettingsClasses.vue"
import UserSettingsConnections from "./UserSettingsConnections.vue"
import UserSettingsNotifications from "./UserSettingsNotifications.vue"
import moduleClubManagement from '@/store/club-management/moduleClubManagement.js'

export default {
  components: {
    UserMailInfo,
    UserSettingsProfile,
    UserSettingsChangePassword,
    UserSettingsClubInfo,
    UserSettingsClasses,
    UserSettingsConnections,
    UserSettingsNotifications,
  },
  data() {
    return {

    }
  },
  methods: {
    getClubData() {
      this.$store.dispatch("clubManagement/getClubData")
        .then(res => { })
        .catch(err => { })
    },
  },
  computed: {
    isSmallerScreen() {
      return this.$store.state.windowWidth < 768
    }
  },
  created() {
    if(!moduleClubManagement.isRegistered) {
        this.$store.registerModule('clubManagement', moduleClubManagement)
        moduleClubManagement.isRegistered = true
    }

    this.getClubData()
  },
}
</script>

<style lang="scss">
#profile-tabs {
  .vs-tabs--content {
    padding: 0;
  }
}
</style>
